export default __webpack_public_path__ + "static/media/tasks.678cbf4b.svg";